import {
  IconAdjustments,
  IconBrandAuth0,
  IconCalendarStats,
  IconCash,
  IconFileAnalytics,
  IconFileText,
  IconGauge,
  IconNotes,
  IconPhoto,
  IconPresentationAnalytics,
  IconTrash,
} from "@tabler/icons-react";
import { LinksGroupProps } from "../../_base/model/_base/LinksGroupProps";

export const _sideNavData: LinksGroupProps[] = [
  // {
  //   label: "Trang chủ",
  //   icon: IconGauge,
  //   // link: "/",
  // },
  {
    label: "Quản lý bán hàng",
    link: "/sales-manager",
    icon: IconNotes,
    links: [
      {
        label: "Danh sách đơn hàng",
        link: "/sales-manager/order-list",
      },
      {
        label: "Danh sách đơn AI",
        link: "/sales-manager/order-ai",
      },
      // {
      //   label: "Phương thức thanh toán",
      //   link: "payment",
      // },
    ],
  },
  // {
  //   label: "Thông tin địa chỉ",
  //   //  link: "/demo",
  //   icon: IconAddressBook,
  //   links: [
  //     {
  //       label: "Tỉnh/Thành phố",
  //       link: "province",
  //     },
  //     {
  //       label: "Quận/Huyện",
  //       link: "district",
  //     },
  //     {
  //       label: "Phường/Xã",
  //       link: "commune",
  //     },
  //   ],
  // },
  {
    label: "Quản lý sản phẩm",
    link: "/product-manager",
    icon: IconCalendarStats,
    links: [
      {
        label: "Danh sách sản phẩm",
        link: "/product-manager/product-list",
      },
      {
        label: "Chỉnh sửa sản phẩm",
        link: "/product-manager/edit-product/:id",
        hidden: true,
      },
      // {
      //   label: "Trao đổi của người dùng",
      //   link: "/user-comment",
      // },
      // {
      //   label: "Đánh giá của người dùng",
      //   link: "/product-list",
      // },
      // {
      //   label: "Bảng giá cập nhật",
      //   link: "/product-list",
      // },
      {
        label: "Danh mục sản phẩm",
        link: "/product-manager/category",
      },
      {
        label: "SP chưa có thuộc tính",
        link: "/product-manager/list-product-no-attribute",
      },
      {
        label: "Danh mục cho SEO",
        link: "/product-manager/category-seo",
      },
      // {
      //   label: "Danh sách Sp mua kèm",
      //   link: "/product-addon",
      // },
      // {
      //   label: "Danh mục cho SEO",
      //   link: "/item-seo",
      // },
      // {
      //   label: "Danh mục thông số kỹ thuật",
      //   link: "/technical-common",
      // },
      // {
      //   label: "Thuộc tính sản phẩm",
      //   link: "/property-list",
      // },

      // {
      //   label: "Danh mục cho SEO",
      //   link: "/product-list",
      // },
      // {
      //   label: "Danh sách thương hiệu",
      //   link: "/product-list",
      // },
      // {
      //   label: "Thuộc tính sản phẩm",
      //   link: "/product-list",
      // },
      {
        label: "Bộ sưu tập",
        link: "/product-manager/collection",
      },
      {
        label: "Sản phẩm bộ sưu tập",
        link: "/product-manager/collection/product",
        hidden: true,
      },

      {
        label: "Quản lý khung sản phẩm",
        link: "/product-manager/collection-frame",
      },
      // {
      //   label: "SP/Dịch vụ đi kèm",
      //   link: "/product-list",
      // },
      {
        label: "Biến thể sản phẩm",
        link: "/product-manager/config-group",
      },
      {
        label: "Biến thể sản phẩm v2",
        link: "/product-manager/config-group-v2",
      },
      {
        label: "Nhóm cấu hình sản phẩm chỉnh sửa",
        link: "/product-manager/config-group/edit",
        hidden: true,
      },
      {
        label: "Quản lý thuộc tính",
        link: "/product-manager/attribute",
      },
      {
        label: "Danh sách thương hiệu",
        link: "/product-manager/brand",
      },
    ],
  },

  {
    label: "Quản lý bài viết",
    link: "/article-manager",
    icon: IconPresentationAnalytics,
    links: [
      {
        label: "Bài viết",
        link: "/article-manager/article-list",
      },
      {
        label: "Tạo mới bài biết",
        link: "/article-manager/create-article",
        hidden: true,
      },
      {
        label: "Chỉnh sửa bài viết",
        link: "/article-manager/edit-article/:id",
        hidden: true,
      },
      {
        label: "Danh mục bài viết",
        link: "/article-manager/article-category",
      },
      {
        label: "Bài viết khen thưởng",
        link: "/article-manager/article-reward",
      },
    ],
  },
   {
    label: "Quản lý bảo hành",
    link: "/warranty-manager",
    icon: IconNotes,
    links: [
      {
        label: "Danh mục hãng",
        link: "/warranty-manager/brand-category",
      },
    ],
  },
  {
    label: "Tính năng Redirect ",
    link: "/redirect",
    icon: IconPresentationAnalytics,
    links: [
      {
        label: "Tính năng Redirect",
        link: "/redirect/url-redirect",
      },
    ],
  },

  {
    label: "Combo Set",
    link: "/combo",
    icon: IconPresentationAnalytics,
    links: [
      {
        label: "Danh sách combo set",
        link: "/combo/combo-set",
      },
      {
        label: "Chỉnh sửa combo set",
        link: "/combo/combo-set-edit/:id",
        hidden: true,
      },
      {
        label: "Tạo mới combo set",
        link: "/combo/combo-set-add",
        hidden: true,
      },
    ],
  },

  {
    label: "Quản lý khách hàng",
    link: "/customer",
    icon: IconPresentationAnalytics,
    links: [
      // {
      //   label: "Danh sách khách hàng",
      //   link: "/customer",
      // },
      // {
      //   label: "Danh sách nhóm khách hàng",
      //   link: "/customer-group",
      // },
      // {
      //   label: "Danh sách khách hàng liên hệ",
      //   link: "/list-menu1",
      // },
      // {
      //   label: "Danh sách khách hàng góp ý",
      //   link: "/list-menu1",
      // },
      // {
      //   label: "Danh sách khách hàng nhập tin",
      //   link: "/list-menu1",
      // },
      {
        label: "Tổng hợp trao đổi của người dùng",
        link: "/customer/user-comment",
      },
      {
        label: "Tổng hợp đánh giá của người dùng",
        link: "/customer/user-review",
      },
    ],
  },
  {
    label: "Quản lý Marketing",
    link: "/marketing-manager",
    icon: IconFileAnalytics,
    links: [
      // {
      //   label: "Khuyến mại theo sản phẩm",
      //   link: "/list-menu1",
      // },
      // {
      //   label: "Phiếu giảm giá - Voucher",
      //   link: "/coupon",
      // },
      {
        label: "Danh sách banner",
        link: "/marketing-manager/banner",
      },
      {
        label: "Danh sách vị trí banner",
        link: "/marketing-manager/banner-location",
      },
      // {
      //   label: "Banner pop-up",
      //   link: "/list-menu1",
      // },
      // {
      //   label: "Poster",
      //   link: "/list-menu1",
      // },
      // {
      //   label: "Hình nền website",
      //   link: "/list-menu1",
      // },
      {
        label: "Facebook Product Ads",
        link: "/marketing-manager/product-ads-category",
      },
      // {
      //   label: "Cài biểu tượng giảm giá",
      //   link: "/list-menu1",
      // },
      // {
      //   label: "Deal/giờ vàng",
      //   link: "/marketing-manager/product-deal",
      // },
      // {
      //   label: "Deal giá sốc",
      //   link: "/marketing-manager/deal-shocking-price",
      // },
      // {
      //   label: "Khuyến mại Build PC",
      //   link: "/list-menu1",
      // },
      // {
      //   label: "Upload Excel SEO sản phẩm",
      //   link: "/list-menu1",
      // },
      {
        label: "Update Excel SEO sản phẩm",
        link: "/marketing-manager/product-seo-upload-excel",
      },
      {
        label: "Quản lý chi nhánh",
        link: "/Config/working-time",
      },
    ],
  },
  {
    label: "Quản lý Nội dung",
    link: "/fixed-content",
    icon: IconAdjustments,
    links: [
      {
        label: "Danh sách nội dung cố định",
        link: "/fixed-content/fixed-content",
      },
      {
        label: "Danh sách ảnh khách hàng",
        link: "/fixed-content/image-content-KH",
      },
      // {
      //   label: "Danh sách danh mục nội dung cố định",
      //   link: "/fixed-content-type",
      // },
      {
        label: "Danh sách media",
        link: "/fixed-content/media",
      },
      // {
      //   label: "Danh sách danh mục media",
      //   link: "/media-group",
      // },
      // {
      //   label: "Danh sách thương hiệu",
      //   icon: "logoMaps",
      //   path: "unit/home",
      // },
      {
        label: "Quản lý nội dung menu",
        link: "/fixed-content/fixed-menu",
      },
      {
        label: "Block trang chủ",
        link: "/fixed-content/home-block",
      },
    ],
  },
  {
    label: "Quản lý Thu cũ - Đổi mới",
    link: "/trade-in",
    icon: IconNotes,
    links: [
      {
        label: "Danh sách đơn đăng ký",
        link: "/trade-in/overview",
      },
      {
        label: "Ngành hàng & Quy tắc phân loại",
        link: "/trade-in/category",
      },
      {
        label: "Sản phẩm thu mua",
        link: "/trade-in/product",
      },
      {
        label: "Sản phẩm lên đời",
        link: "/trade-in/upgrade-product",
      },
    ],
  },
  // {
  //   label: "Sản phẩm cấu hình",
  //   // /  link: "/menu",
  //   icon: IconLock,
  //   links: [
  //     {
  //       label: "Danh sách Menu",
  //       link: "/list-menu1",
  //     },
  //     // {
  //     //   label: "Danh sách thương hiệu",
  //     //   icon: "logoMaps",
  //     //   path: "unit/home",
  //     // },
  //   ],
  // },
  // {
  //   label: "Xây dựng máy tính",
  //   link: "/buld-pc",
  //   icon: IconNotes,
  //   links: [
  //     {
  //       label: "Link kiện xây dựng",
  //       link: "/buld-pc/build-pc-accessory",
  //     },
  //     // {
  //     //   label: "Danh sách thương hiệu",
  //     //   icon: "logoMaps",
  //     //   path: "unit/home",
  //     // },
  //   ],
  // },

  {
    label: "Quản lý Trả góp",
    link: "/installment",
    icon: IconCash,
    links: [
      // {
      //   label: "Danh sách đơn hàng",
      //   link: "/installment-order",
      // },
      {
        label: "Cài đặt trả góp",
        link: "/installment/installment-setting",
      },
    ],
  },
  // {
  //   label: "Quản lý Thống kê",
  //   // /  link: "/menu",
  //   icon: IconNotes,
  //   links: [
  //     {
  //       label: "Thống kê hành vi",
  //       link: "/behavioral-statistics",
  //     },
  //     {
  //       label: "Sản phẩm thêm vào giỏ nhiều",
  //       link: "/most-view-product",
  //     },
  //     {
  //       label: "Sản phẩm mua nhiều",
  //       link: "/most-add-cart-product",
  //     },
  //     {
  //       label: "Từ khoá tìm kiếm",
  //       link: "/search-keyword",
  //     },
  //   ],
  // },
  {
    label: "Quản lý Hệ thống",
    link: "/Config",
    icon: IconNotes,
    links: [
      // {
      //   label: "Config Web",
      //   link: "/Config/config-web",
      // },
      // {
      //   label: "Cấu hình hệ thống",
      //   link: "/Config/app-setting-more",
      // },
      {
        label: "Danh sách tag",
        link: "/Config/tag",
      },
      {
        label: "Đồng bộ dữ liệu",
        link: "/Config/data-synchronization",
      },
      {
        label: "FAQs",
        link: "/Config/faq",
      },
      {
        label: "Danh sách FAQs",
        link: "/Config/faq/:id",
        hidden: true,
      },

      // {
      //   label: "Url redirect",
      //   link: "/url-redirect",
      // },
    ],
  },
  {
    label: "Quản lý Form đăng ký",
    link: "/collection",
    icon: IconNotes,
    links: [
      // {
      //   label: "Chờ mua sản phẩm",
      //   link: "/collection/collection-form",
      // },
      {
        label: "Tuyển dụng",
        link: "/collection/collection-recruitment",
      },
      {
        label: "Bài viết tuyển dụng",
        link: "/collection/collection-recruitment-article",
      },
      {
        label: "Yêu cầu bảo hành",
        link: "/collection/collection-warranty",
      },
      // {
      //   label: "Nhận bài viết mới qua email",
      //   link: "/email-form",
      // },
      // {
      //   label: "Danh sách thương hiệu",
      //   icon: "logoMaps",
      //   path: "unit/home",
      // },
    ],
  },
  {
    label: "Quản lý phản hồi",
    link: "/feedback-manager",
    icon: IconNotes,
    links: [
      // {
      //   label: "Danh sách khách hàng quan tâm thông tin",
      //   link: "customer-interest",
      // },
      {
        label: "Danh sách khách hàng nhập tin",
        link: "/feedback-manager/customer-input",
      },
      {
        label: "Khách hàng gửi liên hệ",
        link: "/feedback-manager/customer-review",
      },
      {
        label: "Thắc mắc, góp ý của khách hàng",
        link: "/feedback-manager/customer-complaint",
      },
    ],
  },
  {
    label: "Quản lý văn bản",
    link: "/document-manager",
    icon: IconFileText,
    links: [
      {
        label: "Danh sách công văn",
        link: "/document-manager/congvan-list",
      },
      {
        label: "Thêm mới công văn",
        link: "/document-manager/create-congvan-list",
        hidden: true,
      },
      {
        label: "Chỉnh sửa công văn",
        link: "/document-manager/edit-congvan-list",
        hidden: true,
      },
      {
        label: "Hệ thống tài liệu",
        link: "/document-manager/he-thong-tai-lieu-list",
      },
    ],
  },
  {
    label: "Bài viết khen thưởng",
    link: "/article-reward",
    icon: IconPresentationAnalytics,
    links: [
      {
        label: "Bài viết khen thưởng",
        link: "/article-reward/article-reward-list",
      },
    ],
  },
  {
    label: "Phân quyền",
    link: "/decentralization",
    icon: IconBrandAuth0,
    links: [
      {
        label: "Nhóm menu",
        link: "/decentralization/menu-group",
      },
      {
        label: "Nhóm chức năng",
        link: "/decentralization/api-group",
      },
      {
        label: "Log Web",
        link: "/decentralization/log-web",
      },
    ],
  },
  {
    label: "Upload Image",
    link: "/upload",
    icon: IconPhoto,
    links: [
      {
        label: "Upload Image",
        link: "/upload/upload-image-online",
      },
    ],
  },
  {
    label: "Xóa cache",
    link: "/clear-cache",
    icon: IconTrash,
    links: [
      {
        label: "Xóa cache",
        link: "/clear-cache",
      },
    ],
  },
  // {
  //   label: "Quản lý Thu cũ- Đổi mới",
  //   // /  link: "/menu",
  //   icon: IconNotes,
  //   links: [
  //     {
  //       label: "Sản phẩm",
  //       link: "/trade-in",
  //     },
  //     {
  //       label: "Đơn thu cũ",
  //       link: "/trade-in-order-old",
  //     },
  //     {
  //       label: "Đơn đổi mới",
  //       link: "/trade-in-order-new",
  //     },
  //   ],
  // },
 

  // {
  //   label: "Voucher",
  //   // /  link: "/menu",
  //   icon: IconNotes,
  //   links: [
  //     {
  //       label: "Kích Hoạt Voucher",
  //       link: "/Voucher",
  //     },
  //     {
  //       label: "Danh sách Voucher ",
  //       link: "/VoucherTest",
  //     },
  //   ],
  // },
];
